Fancybox.bind("[data-fancybox]", {
  l10n: Fancybox.l10n.de_DE,
  plugins: { Compactmode }, 
});
